import { APIS } from '@Config/apis';
import { apiGet, apiPut } from '@Shared/Api/apiClient';

const ensureConfigurationFeatureResponse = (response, fallbackMessage) => {
  if (!response?.featureKey || !Array.isArray(response.fields)) {
    throw new Error(response?.message || fallbackMessage);
  }

  return response;
};

const ensureConfigurationsResponse = (response, fallbackMessage) => {
  if (!Array.isArray(response)) {
    throw new Error(response?.message || fallbackMessage);
  }

  return response.map((configuration) => ensureConfigurationFeatureResponse(configuration, fallbackMessage));
};

const getConfigurationFieldValue = (configuration, fieldKey, defaultValue = null) => {
  const field = configuration?.fields?.find((item) => item.key === fieldKey);
  return field?.value ?? defaultValue;
};

export const getConfigurationBooleanFieldValue = (configuration, fieldKey, defaultValue = false) => {
  const value = getConfigurationFieldValue(configuration, fieldKey, defaultValue);

  if (typeof value === 'boolean') {
    return value;
  }

  if (typeof value === 'string') {
    return value.toLowerCase() === 'true';
  }

  return Boolean(defaultValue);
};

const configurationService = {
  async getConfigurations() {
    const response = await apiGet(APIS.URLS.CONFIGURATIONS, true);
    return ensureConfigurationsResponse(response, 'No fue posible cargar las configuraciones.');
  },

  async getConfiguration(featureKey, config = true) {
    const response = await apiGet(`${APIS.URLS.CONFIGURATIONS}/${featureKey}`, config);
    return ensureConfigurationFeatureResponse(response, 'No fue posible cargar la configuracion.');
  },

  async updateConfiguration(featureKey, fields) {
    const response = await apiPut(`${APIS.URLS.CONFIGURATIONS}/${featureKey}`, {
      fields
    }, true);

    return ensureConfigurationFeatureResponse(response, 'No fue posible guardar la configuracion.');
  }
};

export default configurationService;
